'use client';
import React, { FC, useEffect } from 'react';
import { replaceTokensWithComponents } from '@cat-ecom/common/utils/stringUtils';
import { CatHeading } from 'components/blocks-components';
import { useTranslations } from 'next-intl';
import { REMAN_TYPE } from '../../constants/constants';
import { RemanProduct } from 'services/product/types';
import RemanPartsTable from './reman-parts-table';
import RemanPopUp from '../reman-pop-up/reman-pop-up';
import { DealerPriceAvailabilityResponse } from 'services/dealerPriceAvailability/types';
import { useProductDetailPageContext } from '../../context/product-detail';
import { CartResponse } from 'services/cart/types';
import cx from 'classnames';

interface RemanProductProps {
  data: RemanProduct;
  priceAvailabilityData: DealerPriceAvailabilityResponse;
  locale: string;
  dealerData;
  dealerInformation;
  availRemoveInterimStockFlag: boolean;
  isShowSourcingDetailEnabled: boolean;
  isDeliveryEnabled: boolean;
  catcorp: boolean;
  cartDetails: CartResponse;
  serialNumber: string;
  isPccReleaseRemanReplacement?: boolean;
  isRTL?: boolean;
  currencyLdFeatureFlag?: boolean;
}

const RemanParts: FC<RemanProductProps> = ({
  data,
  priceAvailabilityData,
  locale,
  dealerData,
  dealerInformation,
  availRemoveInterimStockFlag,
  isShowSourcingDetailEnabled,
  isDeliveryEnabled,
  catcorp,
  cartDetails,
  serialNumber,
  isPccReleaseRemanReplacement,
  isRTL = false,
  currencyLdFeatureFlag = false
}) => {
  const { setCartDetails, setSerialNumber } = useProductDetailPageContext();
  const t = useTranslations();
  const { merchandisingAssociations } = data || {};

  useEffect(() => {
    setCartDetails(cartDetails);
    setSerialNumber(serialNumber);
  }, [cartDetails, serialNumber, setCartDetails, setSerialNumber]);

  const remanPartsList = merchandisingAssociations?.filter(
    (item) => item?.associationType === REMAN_TYPE
  );

  const remanPopUpComponent = (isMobile = false) => (
    <div className="cat-u-theme-typography-body-sm">
      {replaceTokensWithComponents(
        t('ALTERNATIVE_CAT_REMAN_PARTS_DESC', { '0': '{0}' }),
        <RemanPopUp isMobile={isMobile} />
      )}
    </div>
  );

  return (
    <>
      {remanPartsList?.length > 0 && (
        <div className="cat-u-margin-top-xl">
          <CatHeading
            variant="title-sm"
            className={cx({ 'text-capitalize': isPccReleaseRemanReplacement })}
          >
            {t('ALTERNATE_CAT_REMAN_TITLE')}
          </CatHeading>
          <div className="d-none d-md-block">{remanPopUpComponent()}</div>
          <div className="d-md-none">{remanPopUpComponent(true)}</div>
          <RemanPartsTable
            remanPartsList={remanPartsList}
            priceAvailabilityData={priceAvailabilityData}
            locale={locale}
            dealerData={dealerData}
            dealerInformation={dealerInformation}
            availRemoveInterimStockFlag={availRemoveInterimStockFlag}
            isShowSourcingDetailEnabled={isShowSourcingDetailEnabled}
            isDeliveryEnabled={isDeliveryEnabled}
            catcorp={catcorp}
            isPccReleaseRemanReplacement={isPccReleaseRemanReplacement}
            isRTL={isRTL}
            currencyLdFeatureFlag={currencyLdFeatureFlag}
          />
        </div>
      )}
    </>
  );
};

export default RemanParts;
